import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import {
    Button,
    Table,
    message,
    Modal,
    Tag,
    Select,
    InputNumber,
    Spin,
    Input,
    Form,
    Descriptions,
    Switch,
    DatePicker,
    Slider,
    Divider,
    Radio,
    Row,
    Col,
} from "antd";
import {
    statusList,
    blindTypesList,
    bonusTypesList,
    publishTypeList,
} from "@/utils/constant";
import { tableSummaries, isMobileDevice } from "@/utils/utils";

export default class MttList extends React.Component {
    state = {
        loading: false, // 是否加载中
        queryParams: {
            // 查询参数
            page: 1,
            limit: 20,
            total: 0,
            status: undefined,
            id: undefined,
            name: undefined,
            date: [],
        },
        statusList: statusList, // 状态列表
        blindTypesList: blindTypesList, // 盲注结构
        bonusTypesList: bonusTypesList, // 奖池分配类型列表
        publishTypeList: publishTypeList, // 发布类型
        data: [], // 表格数据
        selectedMidList: [], // 选中的赛事ID列表
    };

    componentDidMount () {
        this.fetchData();
    }

    /**
     * 获取数据
     */
    fetchData = () => {
        this.setState({ loading: true });
        axios
            .get("/v1/api/mtt/list", {
                params: {
                    ...this.state.queryParams,
                    page_size: this.state.queryParams.page,
                    status:
                        this.state.queryParams.status !== undefined
                            ? this.state.queryParams.status
                            : -1,
                    begin_time:
                        this.state.queryParams.date[0] &&
                        this.state.queryParams.date[0].startOf("day").valueOf() / 1000,
                    end_time:
                        this.state.queryParams.date[1] &&
                        this.state.queryParams.date[1].startOf("day").valueOf() / 1000,
                    date: undefined,
                    total: undefined,
                    page: undefined,
                },
            })
            .then((res) => {
                this.setState({
                    loading: false,
                    queryParams: { ...this.state.queryParams, total: res.count || 0 },
                    data: res.data || [],
                });
            });
    };

    /**
     * 发布
     */
    handlePublish = ({ mid_ }) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["publishMatchConfirm"],
            onOk: () => {
                axios.put(`/v1/api/mtt/release/${mid_}`, { status: 1 }).then((res) => {
                    if (res.code === 1) {
                        message.success(this.props.language["publishSuccessMessage"]);
                        this.fetchData();
                    }
                });
            },
        });
    };

    /**
     * 解散
     */
    handleDissolve = ({ mid_ }) => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["dissolveMatchConfirm"],
            onOk: () => {
                axios.put(`/v1/api/mtt/dissolve/${mid_}`, { status: 4 }).then((res) => {
                    if (res.code === 1) {
                        message.success(this.props.language["dissolveSuccessMessage"]);
                        this.fetchData();
                    }
                });
            },
        });
    };

    /**
     * 批量解散
     */
    handleDissolveBatch = () => {
        Modal.confirm({
            title: this.props.language["hint"],
            content: this.props.language["batchDissolveMatchConfirm"],
            onOk: () => {
                axios
                    .put(`/v1/api/mtt/dissolve`, {
                        status: 4,
                        ids: this.state.selectedMidList,
                    })
                    .then((res) => {
                        if (res.code === 1) {
                            message.success(
                                this.props.language["batchDissolveSuccessMessage"]
                            );
                            this.fetchData();
                        }
                    });
            },
        });
    };

    /**
     * 显示弹窗
     */
    handleShow = (type, item) => {
        switch (type) {
            case "add":
                this.props.history.push(`/mtt_create`);
                break;
            case "edit":
                this.props.history.push(
                    `/mtt_create?data=${encodeURIComponent(JSON.stringify(item))}`
                );
        }
    };

    /**
     * 改变分页
     */
    hanldeChangePage = (pagination) => {
        this.setState(
            {
                queryParams: {
                    ...this.state.queryParams,
                    page: pagination.current,
                    limit: pagination.pageSize,
                },
            },
            () => this.fetchData()
        );
    };

    /**
     * 设置查询数据
     */
    handleSetQueryParamsData = (key, value) => {
        this.setState({
            queryParams: { ...this.state.queryParams, page: 1, [key]: value },
        });
    };

    /**
     * 重置
     */
    handleReset = () => {
        this.setState(
            {
                queryParams: {
                    page: 1,
                    limit: 20,
                    total: 0,
                    status: undefined,
                    id: undefined,
                    name: undefined,
                    date: [],
                },
            },
            () => {
                this.fetchData();
            }
        );
    };

    /**
     * 涨盲时间格式化
     */
    formatRaiseBlindInterval = (date) => {
        // 兼容之前创建的mtt涨盲时间
        if (date < 10000) {
            return `${date / 60} ${this.props.language["minute"]}`;
        } else {
            let applyStart = Number(String(date).slice(-2));
            let applyEnd = Number(String(date).slice(-4, -2));
            let final = Number(String(date).slice(-6, -4));
            if (applyStart === applyEnd && applyEnd === final) {
                return `${applyStart} ${this.props.language["minute"]}`;
            } else {
                return `${Number(String(date).slice(-2))}/${Number(
                    String(date).slice(-4, -2)
                )}/${Number(String(date).slice(-6, -4))} ${this.props.language["minute"]
                    }`;
            }
        }
    };

    render () {
        return (
            <div className="main-container">
                {/* 表头 */}
                <div className="container-header">
                    <InputNumber
                        precision={0}
                        min={0}
                        max={100000000}
                        placeholder={this.props.language["matchIdPlaceholder"]}
                        value={this.state.queryParams.id}
                        onChange={(value) => this.handleSetQueryParamsData("id", value)}
                    />
                    <Input
                        allowClear
                        placeholder={this.props.language["matchNamePlaceholder"]}
                        value={this.state.queryParams.name}
                        onChange={(e) =>
                            this.handleSetQueryParamsData("name", e.target.value)
                        }
                    />
                    <Select
                        allowClear
                        showSearch
                        optionFilterProp="children"
                        placeholder={this.props.language["statusPlaceholder"]}
                        value={this.state.queryParams.status}
                        onChange={(value) => this.handleSetQueryParamsData("status", value)}
                    >
                        {this.state.statusList.map((item, index) => (
                            <Select.Option value={item.value} key={index}>
                                {item.label}
                            </Select.Option>
                        ))}
                    </Select>
                    <DatePicker.RangePicker
                        value={this.state.queryParams.date}
                        onChange={(e) => this.handleSetQueryParamsData("date", e)}
                    />
                    <Button
                        type="primary"
                        icon="search"
                        loading={this.state.loading}
                        onClick={this.fetchData}
                    >
                        {this.props.language["query"]}
                    </Button>
                    <Button type="default" icon="reload" onClick={this.handleReset}>
                        {this.props.language["reset"]}
                    </Button>
                    <Button type="primary" ghost onClick={() => this.handleShow("add")}>
                        {this.props.language["createMatch"]}
                    </Button>
                    {/* <Button type="danger" disabled={!this.state.selectedMidList.length} onClick={this.handleDissolveBatch}>批量解散</Button> */}
                </div>

                {/* 内容 */}
                <div className="container-content">
                    <Table
                        dataSource={this.state.data}
                        pagination={{
                            showTotal: (total) =>
                                `${this.props.language["total"]} ${total} ${this.props.language["item"]}`,
                            showQuickJumper: true,
                            showSizeChanger: true,
                            size: isMobileDevice() ? 'small' : '',
                            pageSizeOptions: ["10", "20", "30", "40"],
                            current: this.state.queryParams.page,
                            pageSize: this.state.queryParams.limit,
                            total: this.state.queryParams.total,
                        }}
                        loading={this.state.loading}
                        onChange={this.hanldeChangePage}
                        scroll={{ x: true }}
                        rowKey={(record, index) => index}
                    // rowSelection={{ type: 'checkbox', fixed: true, getCheckboxProps: (record) => ({ disabled: record.status != 0 && record.status != 1 }), onChange: (mids) => { this.setState({ selectedMidList: mids }) } }}
                    >
                        <Table.Column
                            align="center"
                            title={this.props.language["createTime"]}
                            dataIndex="created_at"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchId"]}
                            dataIndex="mid_"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchName"]}
                            dataIndex="name_cn"
                        />
                        {/* <Table.Column align="center" title={this.props.language["matchDescription"]} dataIndex="desc_cn" /> */}
                        <Table.Column
                            align="center"
                            title={this.props.language["publishType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.publishTypeList.find(
                                    (item2) => item2.value === item.startup_kind
                                )
                                    ? this.state.publishTypeList.find(
                                        (item2) => item2.value === item.startup_kind
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["startMatchTime"]}
                            dataIndex="begin_time"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["matchStatus"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.statusList.find(
                                    (statusItem) => statusItem.value == item.status
                                )
                                    ? this.state.statusList.find(
                                        (statusItem) => statusItem.value == item.status
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["isClone"]}
                            dataIndex=""
                            render={(item) =>
                                item.is_clone
                                    ? this.props.language["yes"]
                                    : this.props.language["no"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["isRoomCowboy"]}
                            dataIndex=""
                            render={(item) =>
                                item.show_cowboy
                                    ? this.props.language["yes"]
                                    : this.props.language["no"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["disableSimulator"]}
                            dataIndex=""
                            render={(item) =>
                                item.block_simulator
                                    ? this.props.language["yes"]
                                    : this.props.language["no"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["blindType"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.blindTypesList.find(
                                    (item2) => item2.value === item.blind_type
                                )
                                    ? this.state.blindTypesList.find(
                                        (item2) => item2.value === item.blind_type
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["satelliteGames"]}
                            dataIndex=""
                            render={(item) =>
                                item.match_type === 1
                                    ? this.props.language["yes"]
                                    : this.props.language["no"]
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["applyFee"]}
                            dataIndex="entry_fee"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["serviceFee"]}
                            dataIndex=""
                            render={(item) => item.fee_rate / 100 + "%"}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["minStartMatchPeople"]}
                            dataIndex="player_min"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["rebuyTime"]}
                            dataIndex="rebuy_times"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["rebuyFee"]}
                            dataIndex="rebuy_fee"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["rebuyChip"]}
                            dataIndex=""
                            render={(item) => item.rebuy_base_time / 100 + "x"}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["addonFee"]}
                            dataIndex="addon_fee"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["addonChip"]}
                            dataIndex=""
                            render={(item) => item.addon_base_time / 100 + "x"}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["currentBlind"]}
                            dataIndex=""
                            render={(item) => `${item.blind_tb_info.sb}/${item.blind_tb_info.bb}(${item.blind_tb_info.ante})`}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["initChip"]}
                            dataIndex=""
                            render={(item) => item.entry_chips / 100}
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["blindTimeStart"]}
                            dataIndex=""
                            render={(item) =>
                                this.formatRaiseBlindInterval(item.raise_blind_interval)
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["endApplyLevel"]}
                            dataIndex="delay_reg_level"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["singleSeatNumber"]}
                            dataIndex="seat_num"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["prizPooAllocation"]}
                            dataIndex=""
                            render={(item) =>
                                this.state.bonusTypesList.find(
                                    (item2) => item2.value === item.bonus_type
                                )
                                    ? this.state.bonusTypesList.find(
                                        (item2) => item2.value === item.bonus_type
                                    ).label
                                    : ""
                            }
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["minPrizePool"]}
                            dataIndex="min_bonus"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["minTicket"]}
                            dataIndex="min_ticket"
                        />
                        <Table.Column
                            align="center"
                            title={this.props.language["operation"]}
                            dataIndex=""
                            fixed={isMobileDevice() ? false : "right"}
                            width={280}
                            render={(item) => (
                                <>
                                    <Button
                                        type="primary"
                                        ghost
                                        disabled={item.status > 0}
                                        onClick={() => this.handleShow("edit", item)}
                                    >
                                        {this.props.language["edit"]}
                                    </Button>
                                    <Button
                                        className="btn-green-ghost ml10"
                                        disabled={item.status > 0}
                                        onClick={() => this.handlePublish(item)}
                                    >
                                        {this.props.language["publish"]}
                                    </Button>
                                    <Button
                                        className="ml10"
                                        type="danger"
                                        ghost
                                        disabled={item.status > 1}
                                        onClick={() => this.handleDissolve(item)}
                                    >
                                        {this.props.language["dissolve"]}
                                    </Button>
                                </>
                            )}
                        />
                    </Table>
                </div>
            </div>
        );
    }
}
